import MarketingList from "./List";
import MarketingCreate from "./Create";
import MarketingDetail from "./Detail";

export { MarketingCreate, MarketingList, MarketingDetail };
